import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Stack, List, ListItem, ListItemText, Typography, Checkbox, Box } from '@mui/material';
import { useConfirm } from 'material-ui-confirm';
import { AUTH_LEVELS } from '../../redux/constants/roles';
import {
  upsertDeploymentAction,
  upsertDeploymentCollectorAction,
} from '../../redux/actions/deployments';
import { dateTime } from '../../utils/parsing';

const CollectorConfiguration = ({ collector, canDisable, canReenable, updateCollector }) => {
  const confirm = useConfirm();
  const [isActive, setIsActive] = useState(collector.active, [collector.active]);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsActive(collector.active);
  }, [collector.active]);

  return (
    <ListItem key={`${collector.private_ip}`} sx={{ display: 'list-item', padding: 0 }}>
      <Box sx={{ border: 1, padding: '5px', margin: '5px' }}>
        <Stack direction="row">
          <Checkbox
            checked={isActive}
            disabled={(isActive && !canDisable) || (!canReenable && !isActive)}
            onChange={(resp, newVal) => {
              confirm({
                title: `Disable collector ${collector.wg_pubkey}`,
                description: `This action will disable the collector shortly. You will not be able to re-enable it. Do you wish to proceed?`,
                confirmationText: 'Disable Collector',
              }).then(({ confirmed }) => {
                if (confirmed) {
                  updateCollector({ ...collector, active: newVal });
                }
              });
            }}
          />
          <ListItemText primary={<strong>Enabled</strong>} />
        </Stack>
        <ListItemText
          primary={
            <>
              <strong>Created At</strong>: {dateTime(collector?.created)}
            </>
          }
        />
        <ListItemText
          primary={
            <>
              <strong>IPs</strong>:
              <List sx={{ listStyleType: 'disc' }}>
                {collector?.device_ips.map((dip) => (
                  <ListItem key={dip} disableGutters sx={{ display: 'list-item' }}>
                    <ListItemText primary={dip} />
                  </ListItem>
                ))}
              </List>
            </>
          }
        />
      </Box>
    </ListItem>
  );
};

const DeploymentConfiguration = ({
  deployment,
  collectors,
  canDisable,
  canReenable,
  updateDeployment,
  updateCollector,
}) => {
  const [isActive, setIsActive] = useState(deployment.active, [deployment]);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsActive(deployment.active);
  }, [deployment.active]);

  return (
    <Box>
      <Typography variant="body2" style={{ fontWeight: 'bold' }}>
        Deployment Details
      </Typography>
      <Checkbox
        checked={isActive}
        disabled={!canDisable}
        onChange={(resp) => {
          updateDeployment({ ...deployment, active: resp.target.checked });
        }}
      />
      Deployment Status
      <Typography variant="body2" style={{ fontWeight: 'bold' }}>
        Collectors
      </Typography>
      <List>
        {collectors.map((collector) => (
          <CollectorConfiguration
            key={collector.private_ip}
            collector={collector}
            canDisable={canDisable}
            canReenable={canReenable}
            updateCollector={updateCollector}
          />
        ))}
      </List>
    </Box>
  );
};

function mapStateToProps(state, { deployment }) {
  const {
    entities: {
      deployments: { configs },
    },
    user: { userAuthLevel },
  } = state;
  return {
    collectors: configs[deployment.site]?.collectors ?? [],
    canDisable: userAuthLevel <= AUTH_LEVELS.ORG_ADMIN,
    canReenable: userAuthLevel === AUTH_LEVELS.SUPER_ADMIN,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateCollector: (collector) => dispatch(upsertDeploymentCollectorAction(collector)),
    updateDeployment: (deployment) => dispatch(upsertDeploymentAction(deployment)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeploymentConfiguration);
